import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Globals } from '../shared/globals';
import { TopNavbarService } from './top-navbar.service';


@Component({
  selector: 'top-navbar',
  templateUrl: './top-navbar.component.html',
  styleUrls: ['./top-navbar.component.css']
})
export class TopNavbarComponent implements OnInit {

  langLabels: Record<string, string> = {
    fi: 'Näytä sisältö suomeksi',
    en: 'Show content in English',
    sv: 'Visa innehåll på svenska',
  };

  errorMessage!: string;
  links: any;
  currentUrl: any;
  linkSubscription: any;


  constructor(
    public globals: Globals,
    private route: ActivatedRoute,
    private router: Router,
    private topNavbarService: TopNavbarService
  ) { }

  ngOnInit() {
    this.getLinks();
    this.currentUrl = this.globals.currentUrl;
  }

  getLinks() {
    this.linkSubscription = this.topNavbarService.getLinks().subscribe(
      links => this.links = links
    );
  }

  changeLang(lang: string) {
    //console.log(lang)
    this.globals.setLang(lang);
    /**
    * Changes the browsers URL to the normalized version of the given URL, and pushes a
    * new item onto the platform's history.
    */
    // tämä vanha tapa ei tee sivulatausta, mutta aiheuttaa ongelmia lukuvuoden vaihtamisen kanssa
    // mikäli routeriin ei saada tietoa nykyisestä urlista 
    //this._platformStrategy.pushState(null, '', this.globals.getCurrentUrl(lang));
    //console.log('kielivaihdon url: ' + this.globals.getCurrentUrl(lang));
    //this.router.navigateByUrl(this.globals.getCurrentUrl(lang)); 
    //this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    //this.router.onSameUrlNavigation = 'reload';
    this.router.navigateByUrl(this.globals.getCurrentUrl(lang)); 
    
    //window.location.href = this.globals.getCurrentUrl(lang);
  }

  changeLang2(event:any , lang: string) {
    if (event.key === "Enter") {
      this.changeLang(lang);
    }
  }

}
